import logReport from './trackUtil';

/**
 * @desc 埋点上报
 * @param {Object} data
 * @example
 *  {
 *      eventId: 'sailing_api_test', // 事件ID
 *      eventLabel: '请求上报',    // 事件描述
 *      attr? : {                // 业务上报数据
 *        time: Date.now(),
 *        api: 'test_api'
 *      }
 *  }
 **/
export function trackEvent(data) {
  return logReport.entry(data);
}
